import EC from './EC'

export default {
  ...EC,
  extended: true,
}
